import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormErrorMessage } from '../error-message';
import { UncontrolledImageUpload } from './uncontrolled';
import { useController } from 'react-hook-form';
export function FormImageUpload({ name, className, onChange, ...props }) {
    const { field, fieldState } = useController({ name });
    return (_jsxs("div", { className: "flex flex-col gap-stack-tight", children: [_jsx(UncontrolledImageUpload, { value: field.value, onChange: (file) => {
                    field.onChange(file);
                    onChange?.(file);
                }, error: fieldState.error?.message, className: className, ...props }), _jsx(FormErrorMessage, { error: fieldState.error?.message })] }));
}
